import { SponsorContentType, SponsorPlacement } from 'api';
import { PodcastPromoPurchaseSelection } from 'state/eventTracking/types';
import { PlacementOption } from './types';

export const WHAT_IS_PODCAST_PROMO_URL =
  'https://learn.headliner.app/hc/en-us/articles/22045858630679-What-is-Podcast-Promo';

export const COMING_SOON_BADGE = 'Coming soon';

export const PLACEMENTS_BY_CONTENT_TYPE: Record<
  SponsorContentType,
  PlacementOption[]
> = {
  podcastEpisode: [
    { placement: 'headlinerApp' },
    { placement: 'publisherNetwork' },
  ],
  youtubeVideo: [
    { placement: 'headlinerApp', isComingSoon: true },
    { placement: 'youtubePromotion' },
  ],
};

export const HAS_TARGETING_BY_PLACEMENT: Record<SponsorPlacement, boolean> = {
  headlinerApp: false,
  publisherNetwork: true,
  youtubePromotion: true,
};

export const TRACKING_SELECTION_BY_PLACEMENT: Record<
  SponsorPlacement,
  PodcastPromoPurchaseSelection
> = {
  headlinerApp: 'Headliner',
  publisherNetwork: 'PubNet',
  youtubePromotion: 'YouTube',
};
